/* The one button on the product page: composes the PRINT FILE in the
   customer's browser, attaches it to the order, and goes straight to checkout.

   WHY THERE IS ONLY ONE BUTTON

   The page used to offer three in sequence — Preview & save, then Save this
   design inside a modal, then Add to cart. People read the first one as the
   purchase and stopped, or saved the design and never found the third. Since
   the finished frame is already on screen at full size beside the form, the
   modal was asking them to approve a picture they were looking at. One button
   now does the lot: compose, attach, add, checkout.

   WHAT IT SENDS

   The browser is given the A4 print master — the finished sheet at 2520x3528
   with the maker's mark already on it and only the photo and signature
   missing — draws those two on, and uploads the result. The Design attached to
   the order IS the file that gets printed.

   THE TRADE, STATED PLAINLY

   Whatever this script can load, anyone who opens the product page can load.
   The print master is full print quality and it is public. That was a
   deliberate choice for a PHYSICAL product: the letters are already readable
   on the site, and an afternoon lost to rebuilding orders was the more
   expensive risk. The catalogue grid images stay watermarked; only the product
   page serves this.

   IT ALSO FAILS LOUDLY

   Orders #1001-#1003 lost their photos in total silence. So nothing is sent
   until the photo is a real File object, and if the master cannot be drawn the
   order still completes, tagged with the reason, carrying the raw photo and
   name so it can be rebuilt by hand. A frame that needs rebuilding is a
   nuisance; a lost sale is worse. */

(function () {
  'use strict';

  var panel = document.querySelector('[data-gift-customizer]');
  if (!panel) return;

  /* Find the photo input FIRST, then walk up to its form. Taking the first
     `form[action*="/cart/add"]` on the page picks up the cart drawer or the
     quick-add markup instead, which is how an earlier version of this script
     silently did nothing at all. */
  var photoInput = document.querySelector('[data-gift-photo-input]');
  if (!photoInput) {
    console.error('[gift-upload] no photo input; theme add-to-cart left alone');
    return;
  }

  var form = photoInput.closest('form');
  if (!form) return;

  var preview = document.querySelector('[data-gift-preview]');
  var nameInput = form.querySelector('[data-gift-name-input]');
  var designInput = form.querySelector('[data-gift-design-input]');
  var frameInput = form.querySelector('[data-gift-frame]');
  var masterUrl = preview && preview.getAttribute('data-print-master');
  var errorBox = panel.querySelector('[data-gift-error]');
  var variant = form.querySelector('[name="id"]');

  /* Dawn's own buttons are removed from view. Leaving them visible is what
     produced the three-button page this replaces. */
  var themeButton = form.querySelector('[name="add"]');
  var payment = form.querySelector('.shopify-payment-button');
  if (themeButton) themeButton.style.display = 'none';
  if (payment) payment.style.display = 'none';

  /* [data-gift-buy-actions] sits OUTSIDE [data-gift-personalise] on purpose:
     gift-preview.js hides that wrapper in "Buy it blank" mode, and a button
     inside it vanishes along with it — a bug that shipped once already and
     left blank-mode shoppers with no way to pay. */
  var actions = panel.querySelector('[data-gift-buy-actions]');
  if (!actions) {
    console.warn(
      '[gift-upload] [data-gift-buy-actions] missing — falling back. ' +
      'If this container ends up inside [data-gift-personalise], the button ' +
      'disappears in "Buy it blank" mode.'
    );
    actions = panel.querySelector('.gift-customizer__actions') || panel;
  }

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'button button--full-width button--primary gift-buy';
  button.setAttribute('data-gift-add', '');
  actions.appendChild(button);

  console.log('[gift-upload] ready; print master:', masterUrl || 'NONE');

  // --------------------------------------------------------------- helpers --

  function currentMode() {
    var checked = form.querySelector('[name="properties[Personalisation]"]:checked');
    return checked ? checked.value : 'Personalised';
  }

  function isPersonalised() {
    return currentMode() !== 'As shown';
  }

  /* A blank frame has nothing to save, so promising to "save" it reads as a
     step the customer has not taken and cannot find. */
  function idleLabel() {
    return isPersonalised() ? 'Save & buy now' : 'Buy now';
  }

  function resetButton() {
    button.disabled = false;
    button.textContent = idleLabel();
  }

  resetButton();

  Array.prototype.forEach.call(
    form.querySelectorAll('[name="properties[Personalisation]"]'),
    function (input) {
      input.addEventListener('change', function () {
        if (!button.disabled) button.textContent = idleLabel();
      });
    }
  );

  function pct(name, fallback) {
    var value = preview && parseFloat(preview.getAttribute(name));
    return isNaN(value) ? fallback : value;
  }

  function fileFrom(input) {
    return input && input.files && input.files.length ? input.files[0] : null;
  }

  function fail(message) {
    if (errorBox) {
      errorBox.textContent = message;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      alert(message);
    }
    resetButton();
  }

  function loadImage(src, allowCrossOrigin) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      /* crossOrigin is only set for ABSOLUTE urls, and this is why order #1005
         came back unprintable. Setting it turns the request into a CORS one:
         if the server does not answer with a matching header the image fails
         to load at all, rather than loading and merely tainting the canvas.
         The master is now served from our own domain, so no CORS is involved
         and nothing needs asking for permission. */
      if (allowCrossOrigin && /^(https?:)?\/\//.test(src)) {
        img.crossOrigin = 'anonymous';
      }
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('could not load ' + src)); };
      img.src = src;
    });
  }

  /* The signature is set in Noto Sans Devanagari, the same typeface the letter
     is typeset in. Waiting for it matters: canvas silently falls back to a
     default face if the font is not ready, and the difference is not obvious
     until the frame is printed. */
  function signatureFont() {
    if (!document.querySelector('[data-gift-font]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.setAttribute('data-gift-font', '');
      link.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@700&display=swap';
      document.head.appendChild(link);
    }
    if (!document.fonts || !document.fonts.load) return Promise.resolve(false);
    return document.fonts.load('700 100px "Noto Sans Devanagari"')
      .then(function () { return true; })
      .catch(function () { return false; });
  }

  function roundedClip(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
    ctx.clip();
  }

  /* Fill the slot, cropping the overflow rather than squashing it — the same
     rule the print script uses, and the same slight upward bias, because faces
     sit above centre. */
  function drawCover(ctx, img, x, y, w, h) {
    var scale = Math.max(w / img.width, h / img.height);
    var dw = img.width * scale;
    var dh = img.height * scale;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) * 0.4, dw, dh);
  }

  function compose(master, photo, signed) {
    var canvas = document.createElement('canvas');
    canvas.width = master.naturalWidth;
    canvas.height = master.naturalHeight;
    var ctx = canvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(master, 0, 0, canvas.width, canvas.height);

    if (photo) {
      var x = pct('data-photo-x', 38) / 100 * canvas.width;
      var y = pct('data-photo-y', 4.5) / 100 * canvas.height;
      var w = pct('data-photo-w', 24) / 100 * canvas.width;
      var h = pct('data-photo-h', 17.14) / 100 * canvas.height;

      ctx.save();
      roundedClip(ctx, x, y, w, h, Math.min(w, h) * 0.045);
      drawCover(ctx, photo, x, y, w, h);
      ctx.restore();
    }

    if (signed) {
      var size = pct('data-name-size', 3.2) / 100 * canvas.width;
      ctx.font = '700 ' + Math.round(size) + 'px "Noto Sans Devanagari", sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#1c1c1a';
      ctx.fillText(
        '— ' + signed,
        pct('data-name-x', 50) / 100 * canvas.width,
        pct('data-name-y', 94.5) / 100 * canvas.height
      );
    }

    return new Promise(function (resolve, reject) {
      // JPEG, not PNG. The same sheet as a PNG is 5MB or more, a slow and
      // failure-prone upload on mobile data; at 0.92 this is a couple of
      // megabytes and indistinguishable in print.
      canvas.toBlob(function (blob) {
        blob ? resolve(blob) : reject(new Error('canvas produced no blob'));
      }, 'image/jpeg', 0.92);
    });
  }

  // ------------------------------------------------------------------ send --

  function send(data) {
    // No Content-Type header on purpose: the browser must set it itself so it
    // can include the multipart boundary. JSON cannot carry a file at all —
    // which was the original bug behind orders #1001-#1003.
    return fetch('/cart/add.js', {
      method: 'POST', body: data, credentials: 'same-origin'
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          throw new Error(body.description || body.message || 'Could not add this to the cart.');
        }
        return body;
      });
    });
  }

  function buy() {
    if (button.disabled) return;
    if (errorBox) errorBox.hidden = true;

    if (!variant || !variant.value) {
      return fail('Something is wrong with this product. Please refresh the page.');
    }

    var mode = currentMode();
    var personalised = mode !== 'As shown';
    var photoFile = fileFrom(photoInput);
    var signed = nameInput ? nameInput.value.trim() : '';

    if (personalised) {
      if (!photoFile) return fail('Please choose a photo first.');
      if (!signed) return fail('Please type the name it should be signed with.');
    }

    button.disabled = true;
    button.textContent = 'Preparing your frame…';

    var data = new FormData();
    data.append('id', variant.value);
    data.append('quantity', '1');
    data.append('properties[Personalisation]', mode);
    if (frameInput && frameInput.value) {
      data.append('properties[_Frame]', frameInput.value);
    }
    if (personalised) {
      data.append('properties[From]', signed);
      // The original photo travels too, so the frame can be rebuilt with a
      // different crop later without going back to the customer.
      data.append('properties[Photo]', photoFile, photoFile.name);
    }

    var photoImage = personalised
      ? loadImage(URL.createObjectURL(photoFile), false)
      : Promise.resolve(null);

    Promise.all([
      masterUrl ? loadImage(masterUrl, true) : Promise.reject(new Error('no master url')),
      photoImage,
      signatureFont()
    ])
      .then(function (parts) {
        return compose(parts[0], parts[1], personalised ? signed : '');
      })
      .then(function (blob) {
        data.append('properties[Design]', blob, (frameInput ? frameInput.value : 'frame') + '--print.jpg');
      })
      .catch(function (error) {
        /* The print master could not be loaded or drawn. Rather than block the
           sale, send whatever proof exists and let the order be rebuilt by
           hand from the raw photo and name, which also travel. */
        console.error('[gift-upload] print compose failed:', error);
        var fallback = fileFrom(designInput);
        if (fallback) data.append('properties[Design]', fallback, fallback.name);
        // The reason travels with the order, not just the console. An order
        // that fails at 2am is diagnosed from the order itself or not at all.
        data.append(
          'properties[_PrintReady]',
          'no — ' + ((error && error.message) || 'unknown') + ' — rebuild by hand'
        );
      })
      .then(function () {
        button.textContent = 'Taking you to checkout…';
        return send(data);
      })
      .then(function () {
        /* Straight to payment. The cart page was a step where people stalled,
           and there is nothing on it they have not already decided. */
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        fail(error.message || 'Could not start checkout. Please try again.');
      });
  }

  button.addEventListener('click', buy);

  /* Pressing Enter in the "Signed by" field submits the form natively, which
     would bypass everything above and post an order with no design on it.
     Capture phase, and registered before gift-preview.js binds its own
     validation, so stopImmediatePropagation wins. */
  form.addEventListener(
    'submit',
    function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      buy();
    },
    true
  );
})();
